import { useCallback, useEffect, useState } from "react";

import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom";

import iLive from "../../assets/images/100-live-with-bg.svg";
import iPast from "../../assets/images/100-past-with-bg.svg";
import iRemin from "../../assets/images/100-remind-with-bg.svg";
import defaultImage from "../../assets/tutorial-items/i10.svg";
import { useMeetingDetailsStore } from "../../contexts/meetingDetails/meetingDetailsContext";
import { useApi } from "../../hooks/useApi";

const MeetingCard = ({ meeting, disabled }) => {
  const { leaveMeeting } = useApi();
  const store = useMeetingDetailsStore();
  const history = useHistory();
  const [waiting, setWaiting] = useState(false);
  const [meetingToRedirect, setMeetingToRedirect] = useState();

  useEffect(() => {
    if (store.leaveProgress === 5) {
      setWaiting(false);
      store.setLeaveComplete();
      store.clearPersistedData().then(() => {
        store.reset();
      });
    }
    store.meeting === null && meetingToRedirect && history.push(`/live/${meetingToRedirect}`);
  }, [store.leaveProgress, store.meeting]);

  const handleClick = useCallback(() => {
    if (store.meeting && store.meeting.mid !== meeting.mid && store.isJoined) {
      setWaiting(true);
      store.updateInitLeaving(true);
      setWaiting(true);
      store.updateInitLeaving(true);
      setMeetingToRedirect(meeting.mid);
      leaveMeeting(store.meeting.mid)
        .then(() => {
          store.setIsLeaving(true);
        })
        .catch((e) => console.log(e));
    } else {
      history.push(`/live/${meeting.mid}`);
    }
  }, []);

  return (
    <div className={`create-meeting-thumbnail ${waiting ? "fn__creating" : ""} ${disabled ? "disable" : "pointer"}`} onClick={handleClick}>
      <div className="meeting-thumbnail-info">
        <div className="space-between">
          <div className="flex">
            <div className="meeting-thumbnail-detail">
              <img src={meeting.status.includes("start") ? iLive : meeting.status.includes("end") ? iPast : iRemin} alt="" />
              <div className="p-r-6"> {meeting.duration || "00:00"} </div>
              <div className="divider-vertical h-12 m-0 m-lr-6" />
              <div className="flex p-l-6">
                Screens
                <div className="badge m-l-4"> {meeting.screens?.length || 0} </div>
              </div>
            </div>
          </div>
        </div>
        <div className="meeting-thumbnail-description">
          <span>{`${meeting.title || ""} [m${meeting.mid}u${meeting.createdBy?.uid}]`}</span>
        </div>
      </div>
      <img src={meeting.img || defaultImage} className="meeting-thumbnail-img" alt="" />
    </div>
  );
};

export default observer(MeetingCard);
